import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './index';

/** Fires a unified page-view event across all telemetry tools on every route change. Must be rendered inside <BrowserRouter>. */
export function RouteChangeTracker() {
    const location = useLocation();

    useEffect(() => {
        trackPageView(location.pathname);
    }, [location.pathname]);

    return null;
}
